<template>
  <div class="searchPersons">
    <v-row v-if="data.assignTypeName == 1">
      <div class="affiliates-container">
        <div class="affiliates-count">
          <label>{{ $t('starAssignment.label.assignAffiliates.title') }}</label>
        </div>
        <div>
          <v-tooltip right>
            <template #activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                @click="dialog = true"
                color="#e9d4f7"
                rounded
                fab
                dark
                class="mx-4 custom-btn"
              >
                <v-icon class="custom-icon">mdi-account-plus-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('starAssignment.label.assignAffiliates.title') }}</span>
          </v-tooltip>
        </div>
      </div>
    </v-row>
    <br />
    <v-row class="table" v-if="showTable && checkedAffiliates.length">
      <v-col cols="12">
        <v-simple-table
          class="table-cell small-table"
          style="align-self: center"
          v-if="data.assignTypeName == 1"
        >
          <thead>
            <tr>
              <th
                scope="col"
                class="table-cell"
                style="
                  color: #6e17a5;
                  text-align: center;
                  font-weight: 500;
                  font-size: 16px;
                "
              >
                {{ $t('starAssignment.label.table.affiliate') }}
              </th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="affiliate in checkedAffiliates"
              :key="affiliate.userId"
            >
              <td class="table-cell">
                {{ affiliate.firstName }} {{ affiliate.middleName }}
                {{ affiliate.lastName }} {{ affiliate.secondLastName }}
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" max-width="600px" persistent>
      <v-card class="container-model">
        <button class="close-button" @click="closeDialog">
          <span class="small-x">X</span>
        </button>
        <v-col cols="12" md="12" sm="6">
          <img
            src="https://ibliss-icons-prod.s3.us-east-1.amazonaws.com/marca_empresarial/image-welcomeDefault.png"
            class="custom-img" lang="logoIbliss" alt="logoIbliss"
          />
        </v-col>
        <h2 class="custom-title">{{ $t('starAssignment.label.search') }}</h2>
        <h3 class="custom-text">{{ $t('starAssignment.label.maxAffiliates') }}</h3>
        <br />
        <v-row no-gutters>
          <v-col cols="12" sm="12" md="12" class="seach">
            <v-text-field
              :label="$t('label.search.title')"
              :placeholder="$t('label.search.text')"
              append-icon="mdi-magnify"
              dense
              v-model="searchTerm"
              outlined
              class="seach"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-list v-if="searchTerm" class="scrollable-list">
          <v-list-item-group v-if="filteredAffiliates.length">
            <v-list-item
              v-for="affiliate in filteredAffiliates"
              :key="affiliate.index"
            >
              <v-list-item-action>
                <v-checkbox
                  v-model="selectedItems"
                  :value="affiliate.userId"
                  color="secondary"
                  @change="toggleAffiliateSelection(affiliate)"
                  :disabled="
                    selectedItems.length >= 10 &&
                    !selectedItems.includes(affiliate.userId)
                  "
                ></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title
                  >{{ affiliate.firstName }} {{ affiliate.middleName }}
                  {{ affiliate.lastName }}
                  {{ affiliate.secondLastName }}</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
          <v-list-item v-else>
            <v-list-item-content>
              <v-list-item-title>
                {{ $t('starAssignment.label.notFoundAffiliate') }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-container class="selected-affiliates">
          <div v-if="checkedAffiliates.length">
            <h4>{{ $t('starAssignment.label.checkedAffiliates') }}</h4>
            <ul>
              <div class="affiliates-grid">
                <div class="column">
                  <div class="affiliate-item">
                    <li
                      v-for="affiliate in firstFiveAffiliates"
                      :key="affiliate.emailAddress"
                    >
                      {{ affiliate.firstName }} {{ affiliate.middleName }}
                      {{ affiliate.lastName }} {{ affiliate.secondLastName }}
                    </li>
                  </div>
                </div>
                <div class="column">
                  <div class="affiliate-item">
                    <li
                      v-for="affiliate in secondFiveAffiliates"
                      :key="affiliate.firstName"
                    >
                      {{ affiliate.firstName }} {{ affiliate.middleName }}
                      {{ affiliate.lastName }} {{ affiliate.secondLastName }}
                    </li>
                  </div>
                </div>
              </div>
            </ul>
          </div>
        </v-container>
        <v-card-actions>
          <v-btn
            :disabled="isConfirmEnabled"
            rounded
            @click="saveChanges"
            color="primary">
            {{ $t('button.confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div style="position: relative;">
      <v-tooltip left style="position: absolute;">
        <template v-slot:activator="{ on, attrs }">
          <v-btn fab fixed bottom right dark large color="primary" v-bind="attrs" v-on="on"
            @click="submitForm('send')">
              <v-icon dark>mdi-email</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('button.send') }}</span>
      </v-tooltip>

      <v-tooltip left style="position: absolute;">
        <template v-slot:activator="{ on, attrs }">
          <v-btn fab fixed bottom right dark large color="primary" v-bind="attrs" v-on="on"
            @click="submitForm('download')" style="margin-bottom: 80px;">
              <v-icon dark>mdi-download</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('button.download') }}</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import i18n from '@/plugins/i18n';
import Swal from "sweetalert2";

import {
  USERSADMIN_M,
  ACTION_GET_STARASSIGNMENT_SEARCHAFFILIATES,
  GET_STARASSIGNMENT_SEARCHAFFILIATES,
} from "@/views/users_admin/store/types/types.js";

import {
  REPORTS_M,
  ACTION_POST_HISTORIC_ASSIGNMENT_DOWNLOAD_REPORT,
  ACTION_POST_HISTORIC_ASSIGNMENT_SEND_REPORT
} from "@/views/reports/store/types/types.js";

export default {
  props: {
    data: {
      type: Object,
    },
  },

  data() {
    return {
      dialog: false,
      selectedItems: [],
      searchTerm: "",
      affiliates: [],
      formData: {},
      showRest: false,
      shapeCount: 0,
      assignedStars: {},
      selectedCategoryId: null,
      checkedAffiliates: [],
      selectedAffiliatesData: [],
      confirmDialog: false,
      showTable: false
    };
  },

  methods: {
    openModal() {
      this.dialog = true;
    },

    closeDialog() {
      this.searchTerm = "";
      this.dialog = false;
    },

    validateForm() {
      this.showErrorMessages = true;
      const errors = {};

      if (!this.data.assignTypeStar) {
        errors.assignTypeStar = this.$t('starAssignment.label.star.title');
      }

      if (!this.data.startDate) {
        errors.startDate = this.$t('novelties.label.startDate');
      }

      if (!this.data.endDate) {
        errors.endDate = this.$t('novelties.label.endDate');
      }

      if (!this.data.assignTypeName) {
        errors.assignTypeName = this.$t('starAssignment.label.assign.title');
      }
      return errors;
    },

    async submitForm(modo) {
      try {
        // Validar el formulario antes de enviarlo
        const validationErrors = this.validateForm();
        
        // Si hay errores de validación, mostrarlos en un único Swal y no enviar el formulario
        if (Object.keys(validationErrors).length > 0) {
          const errorMessages = Object.values(validationErrors).join("<br>");
          Swal.fire({
            icon: "error",
            title: i18n.t('label.errorsValidation.plural.title'),
            html: '<div class="swal-subtitle"><b>'+ i18n.t('label.errorsValidation.text') +':</b></div><br>' + errorMessages,
            confirmButtonColor: '#6E17A5'
          });
          return;
        }

        const dataForSubmit = {
          data: this.prepareDataForSubmit(),
          assignTypeStar: this.data.assignTypeStar
        }

        const historic = modo == 'download' ? await this.postHistoricAssignmentDownload(dataForSubmit) : await this.postHistoricAssignmentSend(dataForSubmit);
        
        if (modo == 'download') {
          if (historic.data.payload.url != null) {
            this.downloadExcelFile(historic.data.payload.url)
          } else {
            Swal.fire({
            icon: "info",
            title: i18n.t('report.label.downloadExcel.title'),
            text: historic.data.payload.message,
            });
            return;
          }
        } else{
          
          const message = historic.status === 202 || !historic.data?.payload?.message
            ? i18n.t('report.label.email.processing')
            : historic.data.payload.message;
          Swal.fire({
            position: 'top-end',
            icon: 'info',
            title: message,
            showConfirmButton: false,
            timer: 2500
          });
          return;
        }
      } catch (error) {
        console.error(i18n.t('report.label.downloadExcel.error'));
        Swal.fire({
          icon: "error",
          title: 'ERROR',
          text: error.response?.data?.payload?.message || i18n.t('report.label.errorText'),
          confirmButtonColor: '#6E17A5'
        });
      }
    },

    downloadExcelFile(responsePayload) {
      window.open(responsePayload, "_blank");
    },

    ...mapActions({
      getActionSearchAffiliates: `${USERSADMIN_M}${ACTION_GET_STARASSIGNMENT_SEARCHAFFILIATES}`,
      postHistoricAssignmentDownload: `${REPORTS_M}${ACTION_POST_HISTORIC_ASSIGNMENT_DOWNLOAD_REPORT}`,
      postHistoricAssignmentSend: `${REPORTS_M}${ACTION_POST_HISTORIC_ASSIGNMENT_SEND_REPORT}`,
    }),

    toggleAffiliateSelection(affiliate) {
      const index = this.checkedAffiliates.findIndex(
        (a) => a.userId === affiliate.userId
      );
      if (index === -1) {
        this.checkedAffiliates.push(affiliate);
      } else {
        this.checkedAffiliates.splice(index, 1);
        this.$delete(this.assignedStars, affiliate.userId);
      }
    },

    async fetchAffiliates() {
      if (this.searchTerm.length >= 3) {
        try {
          await this.getActionSearchAffiliates(this.searchTerm);
        } catch (error) {
          console.error("Error fetching affiliates:", error);
        }
      }
    },

    saveChanges() {
      const newSelectedAffiliates = this.searchAffiliates.filter((affiliate) =>
        this.selectedItems.includes(affiliate.userId)
      );
      this.selectedAffiliatesData = [
        ...new Set([...this.selectedAffiliatesData, ...newSelectedAffiliates]),
      ];

      this.showTable = true;
      this.dialog = false;
      this.searchTerm = "";
    },

    prepareDataForSubmit() {
      if (this.data.assignTypeName == 1) {
        this.searchAffiliates.filter((affiliate) => {
          this.selectedItems.includes(affiliate.userId)
        });
      } else {
        this.selectedItems = null
      }
      
      return {
        startDate: this.data.startDate, 
        endDate: this.data.endDate,
        userIds: this.selectedItems
      };
    },
  },

  computed: {
    ...mapGetters({
      searchAffiliates: [
        `${USERSADMIN_M}${GET_STARASSIGNMENT_SEARCHAFFILIATES}`,
      ],
    }),

    filteredAffiliates() {
      if (this.searchTerm.length < 3) {
        return [];
      }
      const searchTerms = this.searchTerm.toLowerCase().split(/\s+/);
      
      return this.searchAffiliates
        .filter((affiliate) => {
          const fullName = `${affiliate.firstName} ${
            affiliate.middleName || ""
          } ${affiliate.lastName} ${
            affiliate.secondLastName || ""
          }`.toLowerCase();
          return searchTerms.every((term) => fullName.includes(term));
        })
        .map((affiliate) => ({
          ...affiliate,
          isSelected:
            this.selectedItems.includes(affiliate.userId) ||
            this.selectedAffiliatesData.some(
              (a) => a.userId === affiliate.userId
            ),
        }));
    },

    selectedAffiliates() {
      return this.searchAffiliates.filter((affiliate) =>
        this.selectedItems.includes(affiliate.userId)
      );
    },

    firstFiveAffiliates() {
      return this.checkedAffiliates.slice(0, 5);
    },
    secondFiveAffiliates() {
      return this.checkedAffiliates.slice(5, 10);
    },

    isConfirmEnabled() {
      return this.checkedAffiliates.every((affiliate) => {
        const data = this.formData[affiliate.userId];
        this.showTable = false;
        return data > 0;
      });
    },
  },

  watch: {
    searchTerm(newTerm) {
      if (newTerm.length >= 3) {
        this.fetchAffiliates();
      }
    },
  },
};
</script>

<style scoped>

.searchPersons{
  width: 80%;
}

.affiliates-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
}

.affiliates-grid {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}

.affiliates-count {
  color: #ff7900;
  margin-left: 14px;
}

.custom-btn {
  width: 40px;
  height: 40px;
}

.custom-icon {
  font-size: 22px;
  color: #6e17a5 !important;
}

.iconBotton {
  bottom: 10px;
  padding: left;
}

.container-model {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  font-size: 3vh;
  color: #6e17a5;
}

.small-x {
  font-size: smaller;
}

.close-button {
  position: absolute;
  top: 5px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
}

.custom-img {
  width: 170px;
  height: auto;
  display: block;
  margin: 0 auto;
}

.custom-title {
  color: #6e17a5;
  text-align: center;
}

.custom-text {
  font-size: 16px;
  color: #000000;
  font-weight: 300;
  text-align: center;
  margin: 2px;
}

.seach {
  align-items: center;
  width: 450px;
}

.scrollable-list {
  max-height: 200px;
  width: 450px;
  overflow-y: auto;
  border: 1px solid #ff7900;
}

.selected-affiliates {
  margin-top: 10px;
  margin-left: 0;
  text-align: left;
  justify-self: left;
}

.selected-affiliates h4 {
  font-weight: bold;
  color: #4a148c;
  text-align: left;
  font-size: 16px;
  padding-left: 40px;
}

.selected-affiliates ul {
  text-align: left;
  color: #000000;
  padding-left: 60px;
  padding-right: 50px;
}

.selected-affiliates li {
  font-size: 14px;
  color: #000000;
  text-align: left;
}

.table-cell {
  text-align: center;
  border: 1px solid #ff7900;
}

.small-table {
  width: 600px;
  align-items: flex-start;
}

.table {
  margin-top: 20px;
}

.inputCantidad {
  text-align: center;
  width: 50px;
  border: 1px solid #6e17a5;
  border-radius: 5px;
}

.inputCantidad {
  text-align: center;
  width: 50px;
  border: 1px solid #6e17a5;
  border-radius: 5px;
}

@media screen and (max-width: 600px) {
  .cardStyle {
    padding: 8px;
  }

  .custom-title {
    font-size: 24px;
  }

  .custom-text {
    font-size: 14px;
  }

  .v-card-title {
    font-size: 1rem;
  }

  .scrollable-list {
    max-height: 150px;
    width: 340px;
    overflow-y: auto;
    border: 1px solid #ff7900;
  }

  .seach {
    align-items: center;
    width: 340px;
  }

  .selected-affiliates {
    margin-top: 10px;
    padding: auto;
    text-align: left;
    justify-self: left;
    padding-left: 6px;
    padding-right: 0px;
  }

  .selected-affiliates h4 {
    font-weight: bold;
    color: #4a148c;
    text-align: left;
    font-size: 14px;
    padding-left: 0px;
    padding-right: 0px;
  }

  .selected-affiliates ul {
    text-align: left;
    font-size: 10px;
    padding-left: 12px;
    padding-right: 0px;
  }
}
</style>



